import { useEffect, useState } from "react";
import { X, PartyPopper } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { api } from "@/lib/api";

const DISMISS_KEY = "aip_profree_dismissed";

export function ProFreeBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY) === "1") return;
    let alive = true;
    api.get("/public/config")
      .then((r) => { if (alive && r.data?.paywall_enabled === false) setShow(true); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="overflow-hidden bg-gradient-to-r from-primary via-violet-600 to-primary text-primary-foreground"
          data-testid="pro-free-banner"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-1.5 flex items-center justify-center gap-2 text-xs sm:text-sm font-medium">
            <PartyPopper className="h-3.5 w-3.5 shrink-0" />
            <p className="truncate">
              <span className="font-bold">Pro is free for a limited time 🎉</span>
              <span className="hidden sm:inline"> — every Pro feature unlocked. No card needed.</span>
            </p>
            <button
              onClick={dismiss}
              data-testid="pro-free-banner-dismiss"
              aria-label="Dismiss banner"
              className="ml-1 rounded-full p-0.5 hover:bg-white/20 transition-colors shrink-0"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
